import { useEffect, useCallback, useMemo } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

export function CountryModal({ items, onClose }) {
  const handleKeyDown = useCallback((e) => { if (e.key === 'Escape') onClose(); }, [onClose]);
  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';
    return () => { document.removeEventListener('keydown', handleKeyDown); document.body.style.overflow = ''; };
  }, [handleKeyDown]);

  return createPortal(
    <div className="fixed inset-0 z-[60] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative z-10 flex flex-col w-full max-w-lg max-h-[80vh] bg-[var(--surface-primary)] rounded-xl shadow-2xl overflow-hidden mx-4">
        <div className="flex items-center justify-between px-5 py-3.5 border-b border-[var(--border-primary)]">
          <h3 className="text-sm font-semibold text-[var(--text-primary)]">All Countries ({items.length})</h3>
          <button onClick={onClose} className="p-1 rounded hover:bg-[var(--surface-hover)] text-[var(--text-tertiary)]">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="overflow-y-auto divide-y divide-[var(--border-primary)]">
          {[...items].sort((a, b) => a.name.localeCompare(b.name)).map(({ name, count }) => (
            <div key={name} className="flex items-center justify-between px-5 py-2.5">
              <span className="text-sm text-[var(--text-primary)]">{name}</span>
              <span className="text-xs font-semibold text-[var(--text-tertiary)] bg-[var(--surface-tertiary)] px-2 py-0.5 rounded-full">
                {count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>,
    document.body,
  );
}
